import { render, staticRenderFns } from "./EquityPerformanceSection.vue?vue&type=template&id=6f28f70e&scoped=true"
import script from "./EquityPerformanceSection.vue?vue&type=script&lang=ts"
export * from "./EquityPerformanceSection.vue?vue&type=script&lang=ts"
import style0 from "./EquityPerformanceSection.vue?vue&type=style&index=0&id=6f28f70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f28f70e",
  null
  
)

export default component.exports